import { createContext, useState } from "react";

export const PrayerModalContext = createContext({
  openSubmitPrayerModal: false,
  setOpenSubmitPrayerModal: () => false,
});

export const PrayerModalProvider = ({ children }) => {
  const [openSubmitPrayerModal, setOpenSubmitPrayerModal] = useState(false);
  const value = { openSubmitPrayerModal, setOpenSubmitPrayerModal };
  return (
    <PrayerModalContext.Provider value={value}>
      {children}
    </PrayerModalContext.Provider>
  );
};
